<template>
  <div>
    <section class="hero has-shadow is-grey-ligth">
      <div class="hero-head" style="margin-bottom: 20px;">
        <br />
        <div
          class="container is-flex is-justify-between"
          style="align-items: center; margin: 0px 25px 0 13px;"
        >
          <h1
            class="title has-text-weight-bold has-text-dark is-2"
            style="margin-bottom: 0; text-wrap: nowrap;"
          >
            Cultura
          </h1>
          <div
            v-if="tokenUser && tokenUser.admin"
            class="text-card"
            v-tooltip.bottom="{
              content: empresa.nombre,
              trigger: isMovil ? 'click' : 'manual',
            }"
          >
            <span class="is-size-6 w-full truncate">{{ empresa.nombre }}</span>
            <p
              v-if="proceso.nombre !== '.....'"
              class="is-size-5 has-text-weight-bold truncate"
            >
              {{ proceso.nombre }}
            </p>
          </div>
        </div>
      </div>
      <div class="hero-foot">
        <!-- Menu -->
        <nav class="tabs is-boxed">
          <div class="container">
            <ul v-if="!isMovil">
              <li
                v-bind:class="{ 'is-active': activo('yProceso') }"
                @click="selectSection('yProceso', 0, 'Proceso')"
              >
                <a href="#">Proceso</a>
              </li>
              <li
                v-bind:class="{ 'is-active': activo('yEmpleadosn') }"
                @click="selectSection('yEmpleadosn', 1, 'Empleados')"
              >
                <a href="#">Empleados</a>
              </li>
              <li
                v-bind:class="{ 'is-active': activo('yEncuestas') }"
                @click="selectSection('yEncuestas', 2, 'Encuestas')"
              >
                <a href="#">Encuestas</a>
              </li>
              <li
                v-bind:class="{ 'is-active': activo('yDatos') }"
                @click="selectSection('yDatos', 3, 'Datos')"
              >
                <a href="#">Datos</a>
              </li>
              <li
                v-bind:class="{ 'is-active': activo('yResultado') }"
                @click="selectSection('yResultado', 4, 'Resultados')"
              >
                <a href="#">Resultados</a>
              </li>
              <li
                v-bind:class="{ 'is-active': activo('yFiles') }"
                @click="selectSection('yFiles', 4, 'Anexos')"
              >
                <a href="#">Anexos</a>
              </li>
            </ul>
            <ul v-if="isMovil">
              <li
                class="is-active"
                v-on:click="showMenuMobile = !showMenuMobile"
              >
                <a href="javascript:void(0)" class="is-flex">
                  {{ title }}
                  <span class="icon is-small">
                    <i class="material-icons">expand_more</i>
                  </span>
                </a>
              </li>
            </ul>
          </div>
        </nav>
      </div>
    </section>

    <div
      style="display: flex;
      justify-content: left;
      margin-left: 40px;
      text-align: center;"
    >
      <!-- Mobile -->
      <div
        v-if="isMovil"
        class="dropdown"
        :class="showMenuMobile ? 'is-active' : ''"
      >
        <div class="dropdown-menu" role="menu">
          <div class="dropdown-content">
            <a
              href="#"
              class="dropdown-item"
              v-bind:class="{ 'is-active': activo('yProceso') }"
              @click="selectSection('yProceso', 0, 'Proceso')"
            >
              Proceso
            </a>
            <a
              href="#"
              class="dropdown-item"
              v-bind:class="{ 'is-active': activo('yEmpleadosn') }"
              @click="selectSection('yEmpleadosn', 1, 'Empleados')"
            >
              Empleados
            </a>
            <a
              href="#"
              class="dropdown-item"
              v-bind:class="{ 'is-active': activo('yEncuestas') }"
              @click="selectSection('yEncuestas', 2, 'Encuestas')"
            >
              Encuestas
            </a>
            <a
              href="#"
              class="dropdown-item"
              v-bind:class="{ 'is-active': activo('yDatos') }"
              @click="selectSection('yDatos', 3, 'Datos')"
            >
              Datos
            </a>
            <a
              href="#"
              class="dropdown-item"
              v-bind:class="{ 'is-active': activo('yResultado') }"
              @click="selectSection('yResultado', 4, 'Resultados')"
            >
              Resultados
            </a>
            <a
              href="#"
              class="dropdown-item"
              v-bind:class="{ 'is-active': activo('yFiles') }"
              @click="selectSection('yFiles', 5, 'Anexos')"
            >
              Anexos
            </a>
          </div>
        </div>
      </div>
    </div>
    <div class="container">
      <component
        :is="select"
        :proceso="proceso"
        :process="proceso"
        :tokenUser="tokenUser"
        @selproceso="selproceso"
        @changeproceso="changeproceso"
      ></component>
    </div>
  </div>
</template>

<script>
import yProceso from "@/components/cultura/Procesocultura.vue";
import yEmpleadosn from "@/components/cultura/Empleadosc.vue";
import yEncuestas from "@/components/cultura/Rencuestacultura.vue";
import yResultado from "@/components/cultura/Resultadoscultura.vue";
import yDatos from "@/components/cultura/Datoscultura.vue";
import yFiles from "@/components/attached/uploadFilesBoard.vue";
import { mapState } from "vuex";

export default {
  data() {
    return {
      select: "yProceso",
      title: "Proceso",
      proceso: {
        nombre: ".....",
      },
      showMenuMobile: false,
    };
  },
  computed: {
    ...mapState(["tokenUser", "isMovil", "empresa"]),
  },
  methods: {
    selproceso(d) {
      this.proceso = d;
      setTimeout(this.selectSection("yEmpleadosn", "Empleados"), 5000);
    },
    changeproceso(d) {
      this.proceso = d;
    },
    selectSection(d, step, name) {
      if (this.proceso.nombre !== ".....") {
        this.select = d;
        this.title = name;
        this.closeMenuMobile();
      } else {
        this.$store.dispatch("notify", {
          message: `Selecciona un proceso`,
          type: "is-danger",
        });
        this.closeMenuMobile();
      }
    },
    activo(a) {
      if (a === this.select) {
        return true;
      } else {
        return false;
      }
    },
    closeMenuMobile() {
      this.showMenuMobile = false;
    },
  },
  components: {
    yProceso,
    yEmpleadosn,
    yEncuestas,
    yResultado,
    yDatos,
    yFiles,
  },
};
</script>

<style lang="scss" scoped>
.contenedor {
  width: 100%;
  position: absolute;
  z-index: 1;
}

.contenedor2 {
  width: 90%;
  position: absolute;
  z-index: 1;
}

a.dropdown-item.is-active,
button.dropdown-item.is-active {
  background-color: #522687;
  color: #fff;
}

.tabs.is-toggle li.is-active a {
  background-color: #522687;
  border-color: #905fbf;
  color: white;
  z-index: 1;
}

.hero.is-grey-ligth .tabs.is-boxed li.is-active a {
  background-color: white;
  border: solid 0 white;
  color: #522687 !important;
  box-shadow: #00000029 0px 14px 20px;
}

.hero.is-grey-ligth .tabs.is-boxed li:hover a {
  background-color: rgba(191, 191, 191, 0.475);
  border: solid 0 rgba(191, 191, 191, 0.475) !important;
  color: #522687 !important;
}

.hero.is-grey-ligth {
  padding-left: 40px;
}

.hero.is-grey-ligth .tabs.is-boxed a {
  border: 0px solid transparent;
  border-radius: 4px 4px 0 0;
}

.text-card {
  padding: 3px 10px;
  border-radius: 10px;
  background-color: white;
}
</style>



// WEBPACK FOOTER //
// src/components/cultura/Menucultura.vue